import React from 'react/addons';
import $ from 'jquery';
import cx from 'classnames';

import {mailingForm} from 'ofs/payload';

import i18n from 'ofs/i18n';
import ClassNameMixin from 'ofs/utils/ClassNameMixin';
import ValidateEmail from 'ofs/forms/validators/email';

import ProgressButton from 'ofs/components/common/ProgressButton';

var gettext = i18n.gettext;

var PureRenderMixin = React.addons.PureRenderMixin;

var MESSAGES = {
  INPUT_PLACEHOLDER: gettext('Sign-up for email updates'),
  SUBMIT_BUTTON: gettext('Sign-up'),
  SUCCESS_MESSAGE: gettext('Email address submitted. Thanks!')
};


var NewsletterSignUp = React.createClass({
  mixins: [PureRenderMixin, ClassNameMixin],

  propTypes: {
    source: React.PropTypes.string
  },

  getInitialState: function() {
    return {
      errors: null,
      saving: false,
      saved: false
    };
  },

  handleSubmit: function(event) {
    event.preventDefault();

    // validate email
    var email = this.refs.input.getDOMNode().value;
    var emailCheck = ValidateEmail(null, email);

    if (emailCheck instanceof Error) {
      this.setState({
        'errors': [emailCheck.message]
      });
      this.refs.input.getDOMNode().focus();
      return false;
    } else {
      this.setState({
        'errors': null,
        'saving': true
      });
    }

    var data = $(this.refs['form'].getDOMNode()).serialize();

    $.ajax({
      url: mailingForm.url,
      type: 'POST',
      data: data,
      dataType: 'json',
      cache: false,
      success: () => {
        this.setState({
          'saved': true,
          'errors': null,
          'saving': false
        });
      },
      error: (xhr) => {
        this.setState({
          'errors': xhr.responseJSON.errors,
          'saving': false
        });
      }
    });
  },

  render: function() {

    var inputClasses = {
      "ofs-Input": true,
      "ofs-NewsletterSignUp__Input": true,
      "ofs-Input--error": this.state.errors ? true : false
    };

    var buttonClasses = {
      "ofs-Button": true,
      "ofs-Button--secondary": this.props.lightBackground ? false : true,
    };

    var successClasses = {
      'ofs-NewsletterSignUp__Success': true,
      'ofs-NewsletterSignUp__Success--is-visible': this.state.saved,
      'ofs-NewsletterSignUp__Success--dark': this.props.lightBackground,
    };

    var formClasses = {
      '-form--inline': true,
      'ofs-NewsletterSignUp__Form': true,
      'ofs-NewsletterSignUp__Form--is-hidden': this.state.saved
    };

    var errors = [];
    if (this.state.errors) {
      errors = this.state.errors.map(error => <div className="ofs-NewsletterSignUp__Error">{error}</div>);
    }

    return (
      <div className={this.getClassSet({"ofs-NewsletterSignUp": true})}>
        <div className={cx(successClasses)}>
          {MESSAGES.SUCCESS_MESSAGE}
        </div>

        <form action={mailingForm.url} method="POST" acceptCharset="utf-8"
          className={cx(formClasses)}
          onSubmit={this.handleSubmit} ref="form">
          <div className="ofs-Form__Field">
            <div className="ofs-NewsletterSignUp__InputWrapper">
              <input name="email"
                type="text"
                ref="input"
                className={cx(inputClasses)}
                placeholder={MESSAGES.INPUT_PLACEHOLDER} />
              {errors}
            </div>

            <ProgressButton size="small" className={cx(buttonClasses)}
              saving={this.state.saving} finished={this.state.saved} disabled={this.state.saving}>
              {this.props.submitCopy || MESSAGES.SUBMIT_BUTTON}
            </ProgressButton>

            <div className="ofs-Form__HiddenFields">
              <input defaultChecked="checked" name="do_not_tick" type="checkbox"/>
              <input name="required" type="text"/>
              <input defaultChecked="checked" name="guest" type="checkbox"/>
              <input defaultChecked="checked" name="host" type="checkbox"/>
              <input defaultChecked="checked" name="industry" type="checkbox"/>
              <input name="source" type="hidden" value={this.props.source}/>
            </div>
          </div>
        </form>
      </div>
    );
  }
});

export default NewsletterSignUp;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/mailing/NewsletterSignUp.jsx
 **/